export function resetScrollPosition(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const scrollingElement =
    document.scrollingElement ?? document.documentElement;

  scrollingElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.scrollTo(0, 0);
}
